module.exports = __webpack_public_path__ + "img/bg2.a4a3fb70.png";